export default __webpack_public_path__ + "static/media/Oval.29b52396.svg";